<template>
  <div class="main_body  release_page">
    <section id="hero_section">
      <div class="container">
        <!-- navbar starts -->
        <navbar></navbar>

        <!-- navbar ends -->

        <div class="main_logo">
          <img src="@/assets/images/Logo-011.png" alt="Logo-011.png">
        </div>

        <!-- main_realease starts -->
        <section class="main_realease" v-if="this.releases.length">

          <div class="main_thumbnail">
            <img :src="this.releases[0].image" alt="runaway_img.svg">
          </div>
          <div class="main_release_detail">
            <h1 class="mRelease_title">{{this.releases[0].name}}</h1>
            <h5 class="mRelease_location">GM NANASHI</h5>

            <read-more more-str="Read More" class="release_content" :text="description" link="#" less-str="Read Less" :max-chars="150"></read-more>

            <div class="save_share">
              <a :href="this.releases[0].url" target="_blank" class="btn btn_primary btn_save"><i class="fab fa-spotify"></i> Save</a>
              <a :href="this.releases[0].url" target="_blank" class="btn btn_primary btn_share"><i class="fas fa-share"></i> Share</a>
            </div>
          </div>
        </section>
      </div>
        <!-- main_realease ends -->
    </section>
    <!-- header section ends -->

    <!-- all releases starts -->
    <section class="all_releases">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="title_2">
              <h1><span class="border_bottom">RELEASES</span> </h1>
            </div>
          </div>
        </div>

        <div class="released_music_wrapper" v-if="releases.length">

          <!-- first release -->
          <div class="card released_mcard" v-for="release in releases" :key="release.id">
            <a :href="release.url" target="_blank">
              <img class="card-img-top" :src="release.image" alt="runaway_img.svg">
              <div class="card-body">
                <h4 class="card-title">{{release.name}}</h4>
              </div>
            </a>
          </div>
        </div>

      </div>
    </section>
    <!-- <instagram-feed></instagram-feed> -->
  </div>
</template>

<script>
// import InstagramFeed from '../components/InstagramFeed.vue'
import Navbar from '../components/Navbar.vue'
export default {
  name: 'Releases',
  components: {
    Navbar
  },
  data () {
    return {
      releases: [],
      description: ''
    }
  },
  mounted () {
    this.fetchLatestReleaseDescription()
    this.fetchSpotifyAlbums()
  },
  methods: {
    fetchLatestReleaseDescription () {
      this.releases = []
      this.$store.dispatch('fetchAllReleases')
        .then((result) => {
          this.description = result.data.releases[0].description
        })
        .catch((err) => this.$helper.catchHandler(err))
    },
    fetchSpotifyAlbums () {
      this.$store
        .dispatch('fetchSpotifyAlbums')
        .then((resp) => {
          this.releases = resp.data
        })
        .catch((err) => this.$helper.catchHandler(err))
    }
  }
}

</script>

<style scoped>
.released_music_wrapper .card-title{
  text-transform: capitalize;
}
.main_thumbnail img {
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/Releases.vue